<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择关联订单"
      width="1000px"
      top="5vh">
    <vm-table
        ref="vmTable"
        :columns-btn-show="false"
        module="basic"
        url="outStockProductions"
        :filter.sync="filter">
      <template slot="adSearch">
        <vm-search label="关键字：">
          <el-input v-model.trim="filter.filter" placeholder="请输入"/>
        </vm-search>
      </template>
      <el-table-column prop="billNo" align="center" label="领料单号" width="150"/>
      <el-table-column prop="outStockTypeName" align="center" label="领料类型" width="100"/>
      <el-table-column prop="status" align="left" label="状态" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">未提交</span>
          <span v-if="scope.row.status === 1">已提交</span>
          <span v-if="scope.row.status === 2">已出库</span>
        </template>
      </el-table-column>
      <el-table-column prop="relBillNo" align="left" label="关联数据" min-width="400"/>
      <el-table-column
          label="操作"
          fixed="right"
          align="center"
          width="80px"
          prop="action">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)"> 选择 </el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  export default {
    name: "ProductionOrderSelect2",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {
          filter:"",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        console.log(pageNum);
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style></style>
